import { render, staticRenderFns } from "./chooseService.vue?vue&type=template&id=52f0dcb0"
import script from "./chooseService.vue?vue&type=script&lang=js"
export * from "./chooseService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports